import type { Me } from '@gestion-permisos/contracts';

export interface NavigationItem {
  readonly label: string;
  readonly to: string;
}

/**
 * Enlaces de la navegación según `GET /me` (plan 11 §5 y W1): solo roles vigentes, `isDirectorGeneral`
 * y `canRequest`. No consulta solicitudes ni ningún otro endpoint. **No es seguridad:** cada pantalla
 * depende de lo que responda la API (403 o 404 se muestran como tales).
 */
export function navigationFor(me: Pick<Me, 'roles' | 'isDirectorGeneral' | 'canRequest'>): NavigationItem[] {
  const responsable = me.roles.includes('RESPONSABLE');
  const administrador = me.roles.includes('ADMINISTRADOR');
  const items: (NavigationItem | false)[] = [
    { label: 'Inicio', to: '/' },
    me.canRequest && { label: 'Nueva solicitud', to: '/solicitudes/nueva' },
    { label: 'Mis solicitudes', to: '/mis-solicitudes' },
    responsable && { label: 'Mi equipo', to: '/mi-equipo' },
    responsable && { label: 'Panel', to: '/panel-responsable' },
    (responsable || me.isDirectorGeneral) && { label: 'Aprobaciones', to: '/aprobaciones' },
    (responsable || administrador) && { label: 'Analítica', to: '/analitica' },
    administrador && { label: 'Administración', to: '/administracion' },
  ];
  return items.filter((item): item is NavigationItem => item !== false);
}
